export class CreditCardTransactionSearch {
  public constructor() {
    this.ProcessorTransactionId = '';
    this.GatewayId = 0;
    this.StartDate = new Date();
    this.EndDate = new Date();
  }

  public ProcessorTransactionId: string;
  public GatewayId: number;
  public StartDate: Date;
  public EndDate: Date;
}
